module.exports = __webpack_public_path__ + "static/img/4.1309c56.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/zh/4.png
// module id = 54No
// module chunks = 0